import { render, staticRenderFns } from "./ListThresholdsSection.vue?vue&type=template&id=24c0c80b&scoped=true&"
import script from "./ListThresholdsSection.vue?vue&type=script&lang=js&"
export * from "./ListThresholdsSection.vue?vue&type=script&lang=js&"
import style0 from "./ListThresholdsSection.vue?vue&type=style&index=0&id=24c0c80b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c0c80b",
  null
  
)

export default component.exports